import React from 'react';
import cn from 'classnames';
import btn from 'rawr/layout/btn';
import Icon from 'rawr/style/Icon';
import './PopOver.scss';
import Modernizr from 'vendor/modernizr';

export default React.createClass({
	propTypes: {
		hDir: React.PropTypes.oneOf(['left', 'right']),
		vDir: React.PropTypes.oneOf(['up', 'down']),
		width: React.PropTypes.oneOf(['auto', 'narrow', 'medium', 'wide', 'full']),
	},
	getDefaultProps() {
		return {
			width: 'medium'
		};
	},
	getInitialState() {
		return {
			open: this.props.defaultOpen || false
		};
	},
	componentWillMount() {
		this._resizeHandler = _.throttle(this._setDirections, 500);
	},
	componentDidMount() {
		this._setDirections();
	},
	componentDidUpdate(prevProps, prevState) {
		if (prevState.open !== this.state.open) {
			const callback = this.state.open ? 'onOpen' : 'onClose';
			if (callback in this.props) {
				this.props[callback]();
			}
		}
		this._resizeHandler();
	},
	_setDirections() {
		if (!this.state.open || !this.isMounted()) {
			// Since this function is debounced, it can occasionally get called after the
			// event handler is removed at unmount time.
			return;
		}

		const button = this.refs.button.getDOMNode();
		const r = button.getBoundingClientRect();

		const left = r.left;
		const right = window.innerWidth - r.right;
		const above = r.top - 75;
		const below = window.innerHeight - r.bottom - 25;

		this.setState({
			hDir: right > left ? 'right' : 'left',
			vDir: Modernizr.touchevents ? 'down' : (below > above ? 'down' : 'up'),
			height: Math.max(below, above),
			width: Math.max(left, right) + r.width,
		});
	},
	toggle() {
		if (this.state.open) {
			this.setState({open: false, closing: true});
			setTimeout(() => this.isMounted() && this.setState({closing: false}), 500);
		} else {
			this.setState({open: true});
		}
	},
	open() {
		if (!this.state.open) {
			this.toggle();
		}
	},
	close() {
		if (this.state.open && !this.state.closing) {
			this.toggle();
		}
	},
	render() {
		const {children, label, className, hDir, vDir, width, disabled} = this.props;
		const {open, closing} = this.state;
		const btnProp = this.props.btn;

		const svgIconBefore = this.props.svgIconBefore;
		const svgIconAfter = this.props.svgIconAfter;

		const con_classes = cn(
			'pop_over_container',
			`pop_over_${vDir || this.state.vDir}`,
			open ? 'pop_over_open' : 'pop_over_closed',
			className
		);
		const pop_over_classes = cn(
			'pop_over',
			`pop_over_${hDir || this.state.hDir}`,
			`pop_over_${vDir || this.state.vDir}`,
			width && `pop_over_${width}`
		);
		const pop_over_style = {
			maxHeight: Modernizr.touchevents ? null : this.state.height,
			maxWidth: this.state.width,
		};

		var button;
		if (this.props.button) {
			button = <span ref="button">{this.props.button}</span>;
		} else {
			const buttonProps = {
				type: 'button',
				disabled,
				className: cn(
					'pop_over_toggle',
					btnProp || btnProp === undefined ? btn(btnProp) : 'no_btn'
				),
				onClick: this.toggle,
				'data-icon-before': this.props.buttonIconBefore,
				'data-icon-after': this.props.buttonIconAfter,
				ref: 'button'
			};

			button = (
				<button tabIndex="-1" {...buttonProps}>
					{svgIconBefore ? <Icon name={svgIconBefore} size="1.2em" /> : null}
						{label}
					{svgIconAfter ? <Icon name={svgIconAfter} size="1.2em" /> : null}
				</button>
			);
		}

		return (
			<div className={con_classes}>
				{open ? <div className="pop_over_outside" onClick={this.toggle} ></div> : null}
				{button}
				<div className={pop_over_classes} style={pop_over_style}>
					{open || closing ? children : null}
				</div>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/controls/PopOver.jsx
 **/